<template>
  <div class="flex-layout">
    <div>
      <slot name="left" />
    </div>
    <div :style="rightStyle">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CFlexLayout',
  props: {
    alignLeft: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rightStyle() {
      if (this.alignLeft) {
        return { flexGrow: 1 };
      }

      return { marginLeft: 'auto' };
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>
  .flex-layout {
    display: flex;
    align-items: center;
  }
</style>
